import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59b047ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "hezi-disks"
}
const _hoisted_2 = { class: "hezi-disks-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "磁盘管理", -1))
const _hoisted_4 = {
  key: 1,
  class: "disks abnormal"
}
const _hoisted_5 = {
  key: 2,
  class: "hezi-disks-content"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "disks abnormal"
}
const _hoisted_14 = {
  key: 1,
  class: "disks"
}
const _hoisted_15 = {
  key: 1,
  class: "disks-card"
}
const _hoisted_16 = { class: "backup-state" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "hd" }, null, -1))
const _hoisted_18 = { class: "lottie-wrap" }
const _hoisted_19 = {
  key: 0,
  class: "lottie-box",
  id: "device-to-cloud"
}
const _hoisted_20 = {
  key: 1,
  class: "device-to-cloud"
}
const _hoisted_21 = {
  key: 2,
  class: "lottie-box",
  id: "cloud-to-device"
}
const _hoisted_22 = {
  key: 3,
  class: "cloud-to-device"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "cloud" }, null, -1))
const _hoisted_24 = { class: "backup-info" }
const _hoisted_25 = { class: "disk-item" }
const _hoisted_26 = { class: "disk-item-info" }
const _hoisted_27 = {
  key: 0,
  class: "tag-error"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "内置磁盘", -1))
const _hoisted_29 = { class: "disk-item-percet" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { class: "disk-item" }
const _hoisted_32 = { class: "disk-item-info" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", null, "云备份空间")
], -1))
const _hoisted_34 = { class: "disk-item-percet-wrap" }
const _hoisted_35 = { class: "disk-item-percet" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = ["disabled"]
const _hoisted_38 = {
  key: 0,
  class: "disk-item-storage"
}
const _hoisted_39 = {
  key: 1,
  class: "disk-item-storage"
}
const _hoisted_40 = { class: "disks-card-title" }
const _hoisted_41 = { class: "disks-card-head" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { class: "disks-card-body" }
const _hoisted_45 = { class: "disk-item-content" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "disk-item-icon" }, null, -1))
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "disk-item-info-name" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5 5H15V3H4.1C3.49248 3 3 3.49249 3 4.1V19.9C3 20.5075 3.49249 21 4.1 21H19.9C20.5075 21 21 20.5075 21 19.9V10H19V19H5V5Z",
  fill: "#6A707C"
}, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M20.7071 5.70711L11.2071 15.2071L9.79289 13.7929L19.2929 4.29289L20.7071 5.70711Z",
  fill: "#6A707C"
}, null, -1))
const _hoisted_52 = [
  _hoisted_50,
  _hoisted_51
]
const _hoisted_53 = { class: "disk-item-info-tags" }
const _hoisted_54 = {
  key: 0,
  class: "tag-error"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "只读", -1))
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = { key: 1 }
const _hoisted_58 = {
  key: 0,
  class: "disk-item-info-percent"
}
const _hoisted_59 = {
  key: 0,
  class: "disk-item-btn"
}
const _hoisted_60 = ["onClick"]
const _hoisted_61 = ["onClick"]
const _hoisted_62 = ["onClick"]
const _hoisted_63 = { class: "disks-card-title" }
const _hoisted_64 = { class: "disks-card-body" }
const _hoisted_65 = { class: "disk-item" }
const _hoisted_66 = { class: "disk-item-content" }
const _hoisted_67 = { class: "disk-item-info" }
const _hoisted_68 = { class: "disk-item-info-name" }
const _hoisted_69 = { class: "disk-item-info-drive-ip" }
const _hoisted_70 = { class: "disk-item-btn" }
const _hoisted_71 = ["onClick"]
const _hoisted_72 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_WarnAffix = _resolveComponent("WarnAffix")!
  const _component_Fail = _resolveComponent("Fail")!
  const _component_CardItem = _resolveComponent("CardItem")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Page = _resolveComponent("Page")!

  return (_ctx.isLargeViewPort)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", null, [
            _createVNode(_component_Button, {
              icon: "icomoon-add",
              text: "添加Samba",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openAddNetDriveForm('samba')))
            }),
            _createVNode(_component_Button, {
              icon: "icomoon-add",
              text: "添加Webdav",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openAddNetDriveForm('webdav')))
            })
          ])
        ]),
        (!(_ctx.isDeviceOffline || _ctx.isDiskException) && (_ctx.lastVipDay <= 15 && _ctx.svipPayUrl || _ctx.lowCloudSpace))
          ? (_openBlock(), _createBlock(_component_WarnAffix, {
              key: 0,
              "last-vip-day": _ctx.lastVipDay,
              isvip: _ctx.svipInfo.isvip,
              "handle-to-pay-s-vip": _ctx.handleToPaySVip,
              "is-membership-expired": !!(_ctx.lastVipDay <= 15 && _ctx.svipPayUrl)
            }, null, 8, ["last-vip-day", "isvip", "handle-to-pay-s-vip", "is-membership-expired"]))
          : _createCommentVNode("", true),
        (_ctx.isDeviceOffline || _ctx.isDiskException)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_Fail)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.builtInDisk)
                ? (_openBlock(), _createBlock(_component_Card, {
                    key: 0,
                    title: "本地磁盘"
                  }, {
                    carditems: _withCtx(() => [
                      _createVNode(_component_CardItem, {
                        icon: "buildin",
                        name: "内置磁盘",
                        tag: _ctx.builtInDisk?.type,
                        percent: _ctx.builtInDisk?.percent,
                        status: _ctx.renderBuildInDiskState(),
                        readonly: !!_ctx.builtInDisk?.mount && _ctx.builtInDisk?.readonly,
                        "bg-color": _ctx.builtInDisk?.bgColor
                      }, {
                        btns: _withCtx(() => [
                          (!_ctx.isBuildDiskException)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.handleOnFormatBuiltInDisk(true)), ["stop"])),
                                disabled: _ctx.isBuildDiskException
                              }, _toDisplayString(_ctx.builtInDisk?.mount ? '格式化' : '激活'), 9, _hoisted_6))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["tag", "percent", "status", "readonly", "bg-color"]),
                      _createVNode(_component_CardItem, {
                        icon: "cloud",
                        name: "云备份空间",
                        percent: _ctx.cloudSpaceInfo?.percent,
                        status: _ctx.svipInfo.isvip ? `已用${ _ctx.cloudSpaceInfoUsage }/${ _ctx.cloudSpaceInfoSize }` : (
              _ctx.cloudSpaceInfo.usage > 0 && _ctx.lastVipDay >= -30 ? `将于${30 + _ctx.lastVipDay}天后清空` : '暂无云备份空间'
            ),
                        "bg-color": _ctx.cloudSpaceInfo.bgColor,
                        "backup-error": _ctx.backupErrorMessage.isException,
                        "have-bubbles": ""
                      }, {
                        backuptips: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString(_ctx.backupErrorMessage.title), 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.backupErrorMessage.desc), 1)
                        ]),
                        btns: _withCtx(() => [
                          (_ctx.isCanFormatCloudBackup)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                disabled: !_ctx.isCanFormatCloudBackup,
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleCloudRestore('format')))
                              }, "格式化", 8, _hoisted_7))
                            : _createCommentVNode("", true),
                          (_ctx.isCanRestored)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                disabled: !_ctx.isCanRestored,
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleCloudRestore('restore')))
                              }, "恢复数据", 8, _hoisted_8))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["percent", "status", "bg-color", "backup-error"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.externalDisks, (disk, i) => {
                return (_openBlock(), _createBlock(_component_Card, {
                  key: `${disk.serial}-${disk.name}`,
                  title: `外接磁盘-${i + 1}`,
                  "collapse-title": `${disk.mode || disk.name}`
                }, {
                  carditems: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(disk.displayPartitions, (partition) => {
                      return (_openBlock(), _createBlock(_component_CardItem, {
                        icon: "u-disk",
                        key: partition.uuid,
                        name: partition.full_display_name,
                        tag: partition.type,
                        percent: partition.percent,
                        status: _ctx.renderPartitionState(disk, partition),
                        readonly: !!partition.mount && partition.readonly,
                        "bg-color": partition.bgColor,
                        "edit-name": (!disk.hanging && !partition.hanging && !_ctx.actionMap[partition.uuid]) && !!partition.mount,
                        "on-rename": _ctx.handleRename.bind(null, partition)
                      }, {
                        btns: _withCtx(() => [
                          (!disk.hanging && !partition.hanging && !_ctx.actionMap[partition.uuid])
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (partition.mount)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      onClick: ($event: any) => (_ctx.handleOnPartitionAction(partition, 'format'))
                                    }, "格式化", 8, _hoisted_9))
                                  : _createCommentVNode("", true),
                                (!(partition.mount || partition.formatting || partition.mounting))
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      onClick: ($event: any) => (_ctx.handleMountDisk(partition))
                                    }, _toDisplayString(partition.type &&
                    partition.type !== 'unknow' ? '激活' : '格式化'), 9, _hoisted_10))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["name", "tag", "percent", "status", "readonly", "bg-color", "edit-name", "on-rename"]))
                    }), 128))
                  ]),
                  collapsebtn: _withCtx(() => [
                    _createElementVNode("span", {
                      onClick: _withModifiers(($event: any) => (_ctx.handleOnEjectExternalDisk(disk)), ["stop"])
                    }, "弹出", 8, _hoisted_11)
                  ]),
                  _: 2
                }, 1032, ["title", "collapse-title"]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.netDrives, (drive, i) => {
                return (_openBlock(), _createBlock(_component_Card, {
                  key: drive.id,
                  title: `${drive.type}-${i + 1}`
                }, {
                  carditems: _withCtx(() => [
                    _createVNode(_component_CardItem, {
                      icon: drive.type,
                      name: drive.path || drive.ip || drive.id,
                      status: drive.ip,
                      percent: -1
                    }, {
                      btns: _withCtx(() => [
                        _createElementVNode("span", {
                          onClick: ($event: any) => (_ctx.handleOnRemoveNetDrive(drive.id, true, drive.path || drive.ip || drive.id))
                        }, "移除", 8, _hoisted_12)
                      ]),
                      _: 2
                    }, 1032, ["icon", "name", "status"])
                  ]),
                  _: 2
                }, 1032, ["title"]))
              }), 128))
            ]))
      ]))
    : (_openBlock(), _createBlock(_component_Page, {
        key: 1,
        title: "磁盘管理",
        onOnClose: _ctx.handleOnCloseCallback
      }, {
        right: _withCtx(() => [
          _createElementVNode("a", {
            href: "javascript:;",
            class: "qh-icon-new add-external",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleGotoAddExternal && _ctx.handleGotoAddExternal(...args)))
          })
        ]),
        default: _withCtx(() => [
          (_ctx.isDeviceOffline || _ctx.isDiskException)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_Fail)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (!(_ctx.isDeviceOffline || _ctx.isDiskException) && (_ctx.lastVipDay <= 15 && _ctx.svipPayUrl || _ctx.lowCloudSpace))
                  ? (_openBlock(), _createBlock(_component_WarnAffix, {
                      key: 0,
                      "last-vip-day": _ctx.lastVipDay,
                      isvip: _ctx.svipInfo.isvip,
                      "handle-to-pay-s-vip": _ctx.handleToPaySVip,
                      "is-membership-expired": !!(_ctx.lastVipDay <= 15 && _ctx.svipPayUrl)
                    }, null, 8, ["last-vip-day", "isvip", "handle-to-pay-s-vip", "is-membership-expired"]))
                  : _createCommentVNode("", true),
                (_ctx.builtInDisk)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("div", _hoisted_18, [
                          (_ctx.backupUploadable && !_ctx.isBuildDiskException && !_ctx.builtInDisk?.readonly && _ctx.builtInDisk?.mount)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19))
                            : (_openBlock(), _createElementBlock("i", _hoisted_20)),
                          (_ctx.backupDownloadable && !_ctx.isBuildDiskException && !_ctx.builtInDisk?.readonly && _ctx.builtInDisk?.mount)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21))
                            : (_openBlock(), _createElementBlock("i", _hoisted_22))
                        ]),
                        _hoisted_23
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", {
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleOnClickReadonlyPartionToast(_ctx.builtInDisk?.readonly)))
                            }, [
                              (_ctx.builtInDisk?.mount && _ctx.builtInDisk?.readonly)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_27))
                                : _createCommentVNode("", true),
                              _hoisted_28,
                              _createElementVNode("span", null, _toDisplayString(_ctx.builtInDisk?.type), 1)
                            ]),
                            (!_ctx.isBuildDiskException)
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  class: "qh-icon-moreandroid",
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleOnFormatBuiltInDisk()))
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "disk-item-percet-wrap",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleOnClickReadonlyPartionToast(_ctx.builtInDisk?.readonly)))
                          }, [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", {
                                class: _normalizeClass(_ctx.builtInDisk?.bgColor),
                                style: _normalizeStyle({ width: `${_ctx.builtInDisk?.percent}%` })
                              }, null, 6)
                            ]),
                            _createElementVNode("span", {
                              class: "disk-card-operation-btn",
                              onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.handleOnFormatBuiltInDisk(true)), ["stop"])),
                              disabled: _ctx.isBuildDiskException
                            }, _toDisplayString(_ctx.builtInDisk?.mount ? '格式化' : '激活'), 9, _hoisted_30)
                          ]),
                          _createElementVNode("div", {
                            class: "disk-item-storage",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleOnClickReadonlyPartionToast(_ctx.builtInDisk?.readonly)))
                          }, _toDisplayString(_ctx.renderBuildInDiskState()), 1)
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _hoisted_33,
                            (_ctx.isCanRestored || _ctx.isCanFormatCloudBackup)
                              ? (_openBlock(), _createElementBlock("i", {
                                  key: 0,
                                  class: "qh-icon-moreandroid",
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleCloudRestore()))
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", {
                                class: _normalizeClass(_ctx.cloudSpaceInfo.bgColor),
                                style: _normalizeStyle({ width: `${_ctx.cloudSpaceInfo.percent}%` })
                              }, null, 6)
                            ]),
                            (_ctx.isCanFormatCloudBackup)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "disk-card-operation-btn",
                                  disabled: !_ctx.isCanFormatCloudBackup,
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleCloudRestore('format')))
                                }, "格式化", 8, _hoisted_36))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", {
                              class: "disk-card-operation-btn",
                              disabled: !_ctx.isCanRestored,
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleCloudRestore('restore')))
                            }, "恢复数据", 8, _hoisted_37)
                          ]),
                          (_ctx.svipInfo.isvip)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, " 已用" + _toDisplayString(_ctx.cloudSpaceInfoUsage) + "/" + _toDisplayString(_ctx.cloudSpaceInfoSize), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.cloudSpaceInfo.usage > 0 && _ctx.lastVipDay >= -30 ? `将于${30 + _ctx.lastVipDay}天后清空` : '暂无云备份空间'), 1))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.externalDisks, (disk, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "disks-card",
                    key: `${disk.serial}-${disk.name}`
                  }, [
                    _createElementVNode("p", _hoisted_40, " 外接硬盘-" + _toDisplayString(i + 1), 1),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h3", null, _toDisplayString(disk.mode || disk.name), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.actionMap[disk.name]?.text || disk.storageInfo.statusText ||
                `已用${_ctx.formatSize(disk.storageInfo.used)}/${_ctx.formatSize(disk.storageInfo.total)}`), 1)
                      ]),
                      _createElementVNode("i", {
                        class: "qh-icon-moreandroid",
                        onClick: ($event: any) => (_ctx.handleOnEjectExternalDisk(disk))
                      }, null, 8, _hoisted_42),
                      _createElementVNode("span", {
                        class: "disk-card-operation-btn",
                        onClick: ($event: any) => (_ctx.handleOnEjectExternalDisk(disk))
                      }, "弹出", 8, _hoisted_43)
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(disk.displayPartitions, (partition) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "disk-item",
                          key: partition.uuid
                        }, [
                          _createElementVNode("div", _hoisted_45, [
                            _hoisted_46,
                            _createElementVNode("div", {
                              class: "disk-item-info",
                              onClick: ($event: any) => (_ctx.handleOnClickReadonlyPartionToast(partition.readonly))
                            }, [
                              _createElementVNode("div", _hoisted_48, [
                                _createElementVNode("h3", null, _toDisplayString(partition.full_display_name), 1),
                                (_openBlock(), _createElementBlock("svg", {
                                  onClick: ($event: any) => (_ctx.handleOnPartitionAction(partition, 'rename')),
                                  class: "disk-item-info-name-edit",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "24",
                                  height: "24",
                                  viewBox: "0 0 24 24",
                                  fill: "none"
                                }, _hoisted_52, 8, _hoisted_49))
                              ]),
                              _createElementVNode("div", _hoisted_53, [
                                (partition.mount && partition.readonly)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_54, _hoisted_56))
                                  : _createCommentVNode("", true),
                                (partition.type)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_57, [
                                      _createElementVNode("label", null, _toDisplayString(partition.type), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (!_ctx.actionMap[partition.uuid])
                                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(partition.bgColor),
                                      style: _normalizeStyle({ width: `${partition.percent}%` })
                                    }, null, 6)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("p", null, _toDisplayString(_ctx.renderPartitionState(disk, partition)), 1)
                            ], 8, _hoisted_47)
                          ]),
                          (!disk.hanging && !partition.hanging && !_ctx.actionMap[partition.uuid])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                (partition.mount)
                                  ? (_openBlock(), _createElementBlock("i", {
                                      key: 0,
                                      class: "qh-icon-moreandroid",
                                      onClick: ($event: any) => (_ctx.handleOnPartitionAction(partition))
                                    }, null, 8, _hoisted_60))
                                  : _createCommentVNode("", true),
                                (partition.mount)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      class: "disk-card-operation-btn",
                                      onClick: ($event: any) => (_ctx.handleOnPartitionAction(partition, 'format'))
                                    }, "格式化", 8, _hoisted_61))
                                  : _createCommentVNode("", true),
                                (!(partition.mount || partition.formatting || partition.mounting))
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 2,
                                      onClick: ($event: any) => (_ctx.handleMountDisk(partition))
                                    }, _toDisplayString(partition.type &&
                  partition.type !== 'unknow' ? '激活' : '格式化'), 9, _hoisted_62))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.netDrives, (drive, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "disks-card netdrive",
                    key: drive.id
                  }, [
                    _createElementVNode("p", _hoisted_63, _toDisplayString(`${drive.type}-${i + 1}`), 1),
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["disk-item-icon", drive.type])
                          }, null, 2),
                          _createElementVNode("div", _hoisted_67, [
                            _createElementVNode("div", _hoisted_68, [
                              _createElementVNode("h3", null, _toDisplayString(drive.path || drive.ip || drive.id), 1)
                            ]),
                            _createElementVNode("p", _hoisted_69, _toDisplayString(drive.ip), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_70, [
                          _createElementVNode("i", {
                            class: "qh-icon-moreandroid",
                            onClick: ($event: any) => (_ctx.handleOnRemoveNetDrive(drive.id))
                          }, null, 8, _hoisted_71),
                          _createElementVNode("span", {
                            class: "disk-card-operation-btn",
                            onClick: ($event: any) => (_ctx.handleOnRemoveNetDrive(drive.id, true))
                          }, "移除", 8, _hoisted_72)
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ]))
        ]),
        _: 1
      }, 8, ["onOnClose"]))
}